// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"CardsSwiper_swiperContainer__3Ggdn","card":"CardsSwiper_card__8PoSD","active":"CardsSwiper_active__OOwMN"};